import { render, staticRenderFns } from "./ReadAbout.vue?vue&type=template&id=5a852a07&scoped=true"
import script from "./ReadAbout.vue?vue&type=script&lang=js"
export * from "./ReadAbout.vue?vue&type=script&lang=js"
import style0 from "./Return.scss?vue&type=style&index=0&id=5a852a07&prod&scoped=true&lang=scss&external"
import style1 from "./ReadAbout.vue?vue&type=style&index=1&id=5a852a07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a852a07",
  null
  
)

export default component.exports